<script>
import API from "@/api/outers/IBGE";

export default {
  props: {
    value: {
      type: [Number, Object, String],
      required: false,
      default: 0
    },
    error: Boolean
  },

  data() {
    return {
      state: 0,
      states: [],
      loading: false
    };
  },

  computed: {
    errorText() {
      return this.error ? "O campo UF é obrigatório!" : "";
    }
  },

  methods: {
    async getStates() {
      try {
        this.loading = true;
        this.states = await API.getStates();
        this.loading = false;
      } catch (e) {
        this.$emit("error");
      }
    }
  },

  watch: {
    state(id) {
      let state = this.states.find(el => el.id == id);
      this.$emit("input", state);
    }
  },

  async mounted() {
    await this.getStates();
    if (this.value) this.state = this.value.id;
  }
};
</script>

<template>
  <base-select :error="errorText" v-model="state" :loading="loading" label="UF" id="states">
    <option value="0" disabled selected></option>
    <option
      v-for="(state, index) in states"
      :key="index"
      :value="state.id"
    >{{state.sigla}} - {{state.nome}}</option>
  </base-select>
</template>



// WEBPACK FOOTER //
// src/components/_Shared/IBGE/States.vue